import request from '../functions/request'
import { CustomerServiceTmpl } from '../types/common'
// 字典列表
export function publicDictionaryList() {
  return request({
    uri: '/api/public/dictionary/list',
    params: {},
    method: 'POST',
  })
}

export interface IGoodsConfigParams {
  categoryType?: string
  h5Setting?: string
  tagStyle?: string
  buttonStyle?: string
  certificatePage?: string
}

/**
 * @desc 获取配置-根据租户和商品类别
 * @url http://192.168.1.98:3000/project/2051/interface/api/95346
 */
export function getGoodsConfigByType(params: {
  categoryType: string
  tenantCode: string
}): Promise<IGoodsConfigParams> {
  return request({
    uri: '/api/business/member/category/setting',
    params,
    method: 'GET',
    options: {
      resolveData: true,
      hasLoading: false,
    },
  })
}

export function getProExchangeUnits(params: {
  proCode: string
}): Promise<IGoodsConfigParams> {
  return request({
    uri: '/api/business/appointment/product/proExchangeUnits',
    params,
    method: 'POST',
  })
}

// 上传图片
// export const fileImagesApi = `/business/product/upload/image`
// 上传文件 -- 不确定
// export const fileApi = `/business/product/file/uploadFile`

export function fileImages(params) {
  return request({
    uri: '/api/business/product/upload/image',
    method: 'POST',
    params,
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  })
}

/*
 *
 * 产品介绍 | 购票须知popup
 * @url http://192.168.1.98:3000/project/2879/interface/api/106828
 * */
export function getSerInfo(params: { serId: string; projectId?: string }) {
  return request({
    uri: '/api/business/ticket/ser/info',
    params,
    method: 'GET',
  })
}

// 订单取消
export function orderCancel(params: { orderNo: string; remark: string }) {
  return request({
    uri: '/api/business/member/order/cancelOrder',
    params,
    method: 'POST',
  })
}

/**
 * 登录状态检测
 * @returns
 */
export function checkLogin() {
  return request({
    uri: 'api/business/third/supplier/check/login',
    method: 'GET',
  })
}

// 获取图片验证码
export function captchaImage(params = {}) {
  return request({
    uri: '/api/business/member/captcha/image',
    params,
    method: 'GET',
  })
}

// 发送短信
export function memberSendSms(params: {
  ticket: string
  capCode: string
  mobile: string
  tenantCode: string
}) {
  return request({
    uri: '/api/business/member/sendSms',
    params,
    method: 'POST',
  })
}

// 获取图片验证码
export function getLoginSetting(params: {
  categoryType: string
  tenantCode: string
}) {
  return request<{ certificatePage: string }>({
    uri: 'api/business/member/category/setting',
    params,
    method: 'GET',
  })
}

/**
 * 检测是否需要授权
 * @param params
 * @returns
 */
export function checkPageOauth(params: {
  triggerNodeCode: string
  triggerNode: string
  triggerArea?: string
}) {
  return request<{
    needAuthorize: boolean
  }>({
    uri: '/api/business/member/tenant/auth/check',
    params,
    method: 'POST',
  })
}

export interface TenantSettingResp {
  /**
   * 默认语种
   */
  defaultLang?: string;
  /**
   * 启用事件跟踪
   */
  enableEventTracking?: boolean;
  /**
   * 启用语种
   */
  enableLang?: boolean;
  /**
   * 多语言语种
   */
  langs?: Lang[];
  [property: string]: any;
}

export interface Lang {
  lang?: string;
  langName?: string;
  [property: string]: any;
}

export function getTenantSetting(params: { tenantCode?: string }) {
  return request<TenantSettingResp>({
    uri: '/api/business/member/tenant/setting',
    params,
    method: 'GET',
  })
}

export interface ProductCategorySettingLgResp {
  base?: string;
  /**
   * 按钮样式
   */
  buttonStyle?: string;
  /**
   * 凭证页设置
   */
  certificatePage?: string;
  /**
   * h5设置
   */
  h5Setting?: string;
  /**
   * cn.com.dragonpass.business.saas.member.pojo.login.ProductCategorySettingLgResp.LangObj
   */
  langObj?: LangObj;
  /**
   * 标签样式
   */
  tagStyle?: string;
  [property: string]: any;
}

export interface LangObj {
  /**
   * 发卡机构
   */
  cardIssuerName?: string;
  /**
   * 凭证名称
   */
  certificateName?: string;
  /**
   * 客服电话
   */
  customerServiceTels?: CustomerServicePhone[];
  networkEntryText?: string;
  /**
   * 页面标题
   */
  pageTitle?: string;
  proCode?: string;
  tenantCode?: string;
  tipsDesc?: string;
  useRecordEntryText?: string;
  useRuleDesc?: string;
  [property: string]: any;
}

export interface CustomerServicePhone {
  enable?: boolean;
  name?: string;
  tel?: string;
  [property: string]: any;
}

export function getCategorySettingL(params: {
  categoryType?: string
  tenantCode?: string
  proCode?: string
}) {
  return request<ProductCategorySettingLgResp>({
    uri: '/api/business/member/categorySettingL',
    params,
    method: 'POST',
  })
}


export function getCustomPhoneData(params: {
  tenantCode: string;
  code: string;
  // 模板类型，activity=活动，equity_detail=权益详情客服，equity_usedCheck=权益使用人校验弹窗，product_product=商品客服，product_order=订单客服
  type: 'activity' | 'equity_detail' | 'equity_usedCheck' | 'product_product' | 'product_order' | 'points_section' | 'equity_section' | 'nselectx_section';

}) {
  return request<CustomerServiceTmpl>({
    uri: '/api/business/member/customerServiceTemplate/get',
    params,
    method: 'POST',
  })
}

// 获取公告列表，返回一组广告
export function getLastestNoticeList<T>(params: { sectionCode: string }) {
  return request<T>({
    uri: '/api/business/member/notice/list',
    method: 'GET',
    params,
  })
}